/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function EarthGlobeIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "earth-globe", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 8, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 4.5V20.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 4.5C12.5 4.5 17 6.5 17 12.5C17 18.5 12.5 20.5 12.5 20.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 20.5C12.5 20.5 8 18.5 8 12.5C8 6.5 12.5 4.5 12.5 4.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M4.5 12.5H20.5", stroke: "currentColor" }),
        React.createElement("path", { d: "M5.5 16.5H19.5M5.5 8.5H19.5", stroke: "currentColor" })));
}
const ForwardRef = React.forwardRef(EarthGlobeIcon);
export default ForwardRef;
//# sourceMappingURL=earthGlobeIcon.js.map